import {
  CONTACT_DZEN,
  CONTACT_MAX,
  CONTACT_VK,
  OPERATOR_EMAIL,
  OPERATOR_PHONE,
  OPERATOR_PHONE_TEL,
} from '../legal/operator';

export default function SiteContacts({ variant = 'footer' }) {
  const className = variant === 'card'
    ? 'site-contacts site-contacts--card'
    : 'site-contacts site-contacts--footer';

  return (
    <address className={className} aria-label="Контакты">
      <span className="site-contacts-label">Контакты</span>
      <p>
        <a href={`tel:${OPERATOR_PHONE_TEL}`}>{OPERATOR_PHONE}</a>
        {variant === 'footer' ? ' · ' : <br />}
        <a href={CONTACT_MAX} target="_blank" rel="noopener noreferrer">Макс</a>
        {' · '}
        <a href={CONTACT_VK} target="_blank" rel="noopener noreferrer">ВКонтакте</a>
        {' · '}
        <a href={CONTACT_DZEN} target="_blank" rel="noopener noreferrer">Дзен</a>
        {variant === 'footer' ? ' · ' : <br />}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
      </p>
    </address>
  );
}
